var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { NAVIGATE_STEP_KEYS, } from '../../store/configureAccount/types';
import { connect } from 'react-redux';
import { selectConfigureAccount, selectCurrentStep, selectDevPlans, } from '../../store/configureAccount/selectors';
import * as actions from '../../store/configureAccount/actions';
import { compose } from 'redux';
import { CardDetails, ConfigureAccountModalTemplate, DevPlanSelection, EmailVerification, } from '../../components/ConfigAccountModals';
import { selectOrganizationId, selectMe, selectOrg, selectPath, } from '../Root/selectors';
import { useErrorToast, useSuccessToast } from '../../utils/hooks/toast';
import { loadUserProfile } from '../Root/actions';
import { listDeveloperPlansOrg, changeInterval, } from '../../store/orgDevPlan/actions';
import { devPlanTrialRemainsData, validateEmail } from './helper';
import { getInitialState } from '../../store/configureAccount/reducer';
import { useThunkTrigger } from '../../utils/hooks/services';
import { ModalType } from '../Root/models';
import { useConfigureModalSchema } from './schema';
import { selectPaymentModal } from '../PaymentEntry/selectors';
import { useDispatch } from 'react-redux';
import { checkOrgStatusSummery } from '../../store/orgStatusSummery/actions';
import { selectDevPlanSummery, selectStatusLoading, } from '../../store/orgStatusSummery/selectors';
var PAYMENT_MODAL_STATUS = {
    initial: 'INITIAL',
    assign_card: 'ASSIGN_CARD',
    assign_card_failed: 'ASSIGN_CARD_FAILED',
    confirmed: 'CONFIRMED',
};
var fallbackConfigureAccount = getInitialState();
var ConfigureAccountModal = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var closeModal = _a.closeModal, completeConfig = _a.completeConfig, holdModal = _a.holdModal, _j = _a.configureAccount, configureAccount = _j === void 0 ? fallbackConfigureAccount : _j, currentStep = _a.currentStep, getDeveloperPlans = _a.getDeveloperPlans, goToContinueModal = _a.goToContinueModal, goToEmailVerificationModal = _a.goToEmailVerificationModal, goToDevPlanSelectionModal = _a.goToDevPlanSelectionModal, goToCardDetailsModal = _a.goToCardDetailsModal, open = _a.open, organizationId = _a.organizationId, resetState = _a.resetState, setSelectedDevPlanId = _a.setSelectedDevPlanId, user = _a.user, setDevPlanInterval = _a.setDevPlanInterval, organization = _a.organization, purchaseDevPlan = _a.purchaseDevPlan, paymentSettings = _a.paymentSettings, createEmailVerificationData = _a.createEmailVerificationData, sendEmailVerification = _a.sendEmailVerification, verifyEmail = _a.verifyEmail, developerPlans = _a.developerPlans, devPlanStatus = _a.devPlanStatus, setSelectedDevPlanTrialPeriod = _a.setSelectedDevPlanTrialPeriod, goToSuccessModal = _a.goToSuccessModal, refreshOrgDevPlanList = _a.refreshOrgDevPlanList, refreshDevPlanStatus = _a.refreshDevPlanStatus, refreshUserProfile = _a.refreshUserProfile, path = _a.path, _k = _a.type, type = _k === void 0 ? ModalType.WELCOME : _k, customerCardLoading = _a.customerCardLoading;
    var dispatch = useDispatch();
    var schema = useConfigureModalSchema(currentStep, type);
    var _l = useState(false), isLoading = _l[0], setLoading = _l[1];
    var _m = useState(PAYMENT_MODAL_STATUS.initial), paymentModalState = _m[0], setPaymentModalState = _m[1];
    useSuccessToast('Successfully developer plan purchased', [
        currentStep === NAVIGATE_STEP_KEYS.CARD_DETAILS &&
            configureAccount.purchasedDevPlan &&
            !((_b = configureAccount.purchasedDevPlan) === null || _b === void 0 ? void 0 : _b.client_secret),
    ]);
    useErrorToast('An error occurred while purchasing developer plan', [
        currentStep === NAVIGATE_STEP_KEYS.CARD_DETAILS &&
            configureAccount.purchaseDevPlanError,
    ]);
    useErrorToast('An error occurred while sending verification email', [
        currentStep === NAVIGATE_STEP_KEYS.EMAIL_VERIFICATION &&
            configureAccount.sendEmailVerificationError,
    ]);
    useErrorToast('Invalid verification code', [
        currentStep === NAVIGATE_STEP_KEYS.EMAIL_VERIFICATION &&
            !(user === null || user === void 0 ? void 0 : user.email_verified) &&
            ((_c = configureAccount.verifyEmailError) === null || _c === void 0 ? void 0 : _c.status) === 404,
    ]);
    useThunkTrigger(function () {
        holdModal();
    }, currentStep === NAVIGATE_STEP_KEYS.CARD_DETAILS, [currentStep]);
    useThunkTrigger(function () {
        purchaseDevPlan(configureAccount.selectedDevPlanId, organizationId);
    }, currentStep === NAVIGATE_STEP_KEYS.CARD_DETAILS &&
        paymentModalState === PAYMENT_MODAL_STATUS.confirmed, [currentStep, paymentModalState]);
    useThunkTrigger(function () {
        refreshDevPlanStatus(organizationId);
        if (path.includes('/developerPlans')) {
            refreshOrgDevPlanList(organizationId);
        }
    }, currentStep === NAVIGATE_STEP_KEYS.SUCCESS &&
        configureAccount.purchasedDevPlan, [path, currentStep, configureAccount.purchasedDevPlan]);
    var onChangeEmailVerification = useCallback(function (data) {
        var isEmailValidated = validateEmail(data);
        createEmailVerificationData('email', data);
        createEmailVerificationData('valid', isEmailValidated);
    }, [createEmailVerificationData]);
    useEffect(function () {
        if (paymentModalState === PAYMENT_MODAL_STATUS.assign_card) {
            setLoading(true);
        }
        if (paymentModalState === PAYMENT_MODAL_STATUS.confirmed ||
            paymentModalState === PAYMENT_MODAL_STATUS.assign_card_failed) {
            setLoading(false);
        }
    }, [paymentModalState]);
    useEffect(function () {
        var _a;
        if (currentStep === NAVIGATE_STEP_KEYS.CARD_DETAILS &&
            paymentModalState === PAYMENT_MODAL_STATUS.confirmed &&
            configureAccount.purchasedDevPlan &&
            !((_a = configureAccount.purchasedDevPlan) === null || _a === void 0 ? void 0 : _a.client_secret)) {
            goToSuccessModal();
        }
    }, [
        currentStep,
        paymentModalState,
        goToSuccessModal,
        configureAccount.purchasedDevPlan,
    ]);
    useEffect(function () {
        var _a;
        if (currentStep === NAVIGATE_STEP_KEYS.EMAIL_VERIFICATION &&
            ((_a = configureAccount.emailVerification) === null || _a === void 0 ? void 0 : _a.email) === '' &&
            (user === null || user === void 0 ? void 0 : user.email)) {
            onChangeEmailVerification(user.email);
        }
    }, [
        (_d = configureAccount.emailVerification) === null || _d === void 0 ? void 0 : _d.email,
        currentStep,
        onChangeEmailVerification,
        user === null || user === void 0 ? void 0 : user.email,
    ]);
    var onChangeVerificationCode = function (data) {
        var _a;
        createEmailVerificationData('verificationCode', data);
        if ((data === null || data === void 0 ? void 0 : data.length) === 6 && ((_a = configureAccount.emailVerification) === null || _a === void 0 ? void 0 : _a.email)) {
            verifyEmail(configureAccount.emailVerification.email, data);
        }
    };
    var handleCloseModal = function () {
        dispatch(checkOrgStatusSummery(organizationId));
        resetState();
        closeModal();
    };
    var handleCompleteModal = function () {
        dispatch(checkOrgStatusSummery(organizationId));
        resetState();
        completeConfig();
    };
    var backButtonAction = function () {
        switch (currentStep) {
            case NAVIGATE_STEP_KEYS.EMAIL_VERIFICATION:
                goToContinueModal();
                break;
            case NAVIGATE_STEP_KEYS.DEV_PLAN_SELECTION:
                (user === null || user === void 0 ? void 0 : user.email_verified)
                    ? goToContinueModal()
                    : goToEmailVerificationModal();
                break;
            case NAVIGATE_STEP_KEYS.CARD_DETAILS:
                getDeveloperPlans(organizationId);
                goToDevPlanSelectionModal();
                break;
        }
    };
    var backButtonDisableFn = function () {
        if (currentStep === NAVIGATE_STEP_KEYS.START ||
            currentStep === NAVIGATE_STEP_KEYS.SUCCESS)
            return true;
    };
    var renderPrimaryButtonText = function () {
        var _a, _b;
        if (currentStep === NAVIGATE_STEP_KEYS.EMAIL_VERIFICATION &&
            !((_a = configureAccount.emailVerification) === null || _a === void 0 ? void 0 : _a.verificationSent))
            return 'Verify Email';
        return (_b = schema.primaryButtonText) !== null && _b !== void 0 ? _b : '';
    };
    var primaryButtonAction = function () {
        var _a;
        if (currentStep === NAVIGATE_STEP_KEYS.START && !(user === null || user === void 0 ? void 0 : user.email_verified)) {
            return goToEmailVerificationModal();
        }
        else if (currentStep === NAVIGATE_STEP_KEYS.START &&
            (user === null || user === void 0 ? void 0 : user.email_verified)) {
            getDeveloperPlans(organizationId);
            return goToDevPlanSelectionModal();
        }
        else if (currentStep === NAVIGATE_STEP_KEYS.EMAIL_VERIFICATION &&
            !configureAccount.emailVerification.verificationSent) {
            return sendEmailVerification((_a = configureAccount.emailVerification) === null || _a === void 0 ? void 0 : _a.email);
        }
        else if (currentStep === NAVIGATE_STEP_KEYS.EMAIL_VERIFICATION &&
            configureAccount.emailVerification.verificationSent) {
            refreshUserProfile();
            getDeveloperPlans(organizationId);
            return goToDevPlanSelectionModal();
        }
        else if (currentStep === NAVIGATE_STEP_KEYS.DEV_PLAN_SELECTION) {
            return goToCardDetailsModal();
        }
        else if (currentStep === NAVIGATE_STEP_KEYS.CARD_DETAILS) {
            return confirmCardDetails();
        }
        else if (currentStep === NAVIGATE_STEP_KEYS.SUCCESS) {
            return handleCompleteModal();
        }
    };
    var primaryButtonDisableFn = function () {
        var _a, _b, _c;
        if (currentStep === NAVIGATE_STEP_KEYS.DEV_PLAN_SELECTION) {
            return configureAccount.selectedDevPlanId === '';
        }
        else if (currentStep === NAVIGATE_STEP_KEYS.EMAIL_VERIFICATION &&
            !configureAccount.emailVerification.verificationSent) {
            return !(((_a = configureAccount.emailVerification) === null || _a === void 0 ? void 0 : _a.email) &&
                ((_b = configureAccount.emailVerification) === null || _b === void 0 ? void 0 : _b.valid));
        }
        else if (currentStep === NAVIGATE_STEP_KEYS.EMAIL_VERIFICATION &&
            configureAccount.emailVerification.verificationSent) {
            return !((_c = configureAccount.emailVerification) === null || _c === void 0 ? void 0 : _c.verified);
        }
        else {
            return false;
        }
    };
    var primaryButtonLoadingFn = function () {
        if (currentStep === NAVIGATE_STEP_KEYS.CARD_DETAILS) {
            return (configureAccount.purchaseDevPlanLoading ||
                customerCardLoading ||
                paymentSettings.cardAssignLoading ||
                isLoading);
        }
        else {
            return false;
        }
    };
    var renderSecondaryButtonText = function () {
        var _a, _b;
        if (currentStep === NAVIGATE_STEP_KEYS.EMAIL_VERIFICATION &&
            ((_a = configureAccount.emailVerification) === null || _a === void 0 ? void 0 : _a.verificationSent) &&
            !configureAccount.emailVerification.verified)
            return 'Resend Code';
        return (_b = schema === null || schema === void 0 ? void 0 : schema.secondaryButtonText) !== null && _b !== void 0 ? _b : '';
    };
    var secondaryButtonAction = function () {
        var _a, _b;
        if (currentStep === NAVIGATE_STEP_KEYS.EMAIL_VERIFICATION &&
            ((_a = configureAccount.emailVerification) === null || _a === void 0 ? void 0 : _a.verificationSent) &&
            !configureAccount.emailVerification.verified) {
            return sendEmailVerification((_b = configureAccount.emailVerification) === null || _b === void 0 ? void 0 : _b.email);
        }
    };
    var secondaryButtonDisableFn = function () {
        var _a;
        if (currentStep === NAVIGATE_STEP_KEYS.EMAIL_VERIFICATION &&
            ((_a = configureAccount.emailVerification) === null || _a === void 0 ? void 0 : _a.verificationSent) &&
            !configureAccount.emailVerification.verified) {
            return (configureAccount.sendEmailVerificationError ||
                configureAccount.sendEmailVerificationResponse);
        }
        else {
            return false;
        }
    };
    var confirmCardDetails = function () {
        setPaymentModalState(PAYMENT_MODAL_STATUS.assign_card);
    };
    var on3DSSuccess = function () {
        goToSuccessModal();
    };
    var _o = devPlanTrialRemainsData(devPlanStatus.trial_period, devPlanStatus === null || devPlanStatus === void 0 ? void 0 : devPlanStatus.consumed_trial_days, configureAccount.devPlanTrialPeriod), isVisible = _o.isVisible, additionalForSelected = _o.additionalForSelected, remainingForCurrent = _o.remainingForCurrent;
    var renderDevPlanSelectionInfoText = function () {
        return isVisible
            ? "When you\u2019ve selected your Plan and entered your payment details in the next step, you\u2019ll get ".concat(additionalForSelected, " more ").concat(additionalForSelected === 1 ? 'day' : 'days', "  of free trial added to the ").concat(remainingForCurrent, " ").concat(remainingForCurrent === 1 ? 'day' : 'days', " you already have.")
            : '';
    };
    var renderChildren = function () {
        var _a, _b;
        switch (currentStep) {
            case NAVIGATE_STEP_KEYS.EMAIL_VERIFICATION:
                return (_jsx(EmailVerification, { emailVerification: __assign(__assign({}, configureAccount.emailVerification), { email: ((_a = configureAccount.emailVerification) === null || _a === void 0 ? void 0 : _a.email) !== ''
                            ? configureAccount.emailVerification.email
                            : (_b = user === null || user === void 0 ? void 0 : user.email) !== null && _b !== void 0 ? _b : '', verifying: configureAccount.verifyEmailProcessing }), onChangeEmailVerification: onChangeEmailVerification, onChangeVerificationCode: onChangeVerificationCode }));
            case NAVIGATE_STEP_KEYS.DEV_PLAN_SELECTION:
                return (_jsx(DevPlanSelection, { configureAccount: configureAccount, developerPlans: developerPlans === null || developerPlans === void 0 ? void 0 : developerPlans.filter(function (devPlan) { return organization.currency === devPlan.currency; }), setSelectedDevPlanId: function (devPlanId) {
                        return setSelectedDevPlanId(devPlanId);
                    }, setDevPlanInterval: function (interval) {
                        return setDevPlanInterval(interval);
                    }, setSelectedDevPlanTrialPeriod: function (trial) {
                        return setSelectedDevPlanTrialPeriod(trial);
                    } }));
            case NAVIGATE_STEP_KEYS.CARD_DETAILS:
                return (_jsx(CardDetails, { organization: organization, purchasedDevPlan: configureAccount.purchasedDevPlan, on3DSSuccess: on3DSSuccess, paymentModalState: paymentModalState, onCardAssignStatusChanged: function (status) { return setPaymentModalState(status); }, setLoading: setLoading }));
            default:
                return _jsx(_Fragment, {});
        }
    };
    return (_jsx(ConfigureAccountModalTemplate, __assign({ open: open, closeModal: handleCloseModal, title: (_e = schema.title) !== null && _e !== void 0 ? _e : '', description: (_f = schema.description) !== null && _f !== void 0 ? _f : '', description2: currentStep === NAVIGATE_STEP_KEYS.DEV_PLAN_SELECTION
            ? renderDevPlanSelectionInfoText()
            : (_g = schema === null || schema === void 0 ? void 0 : schema.description2) !== null && _g !== void 0 ? _g : '', description3: (_h = schema === null || schema === void 0 ? void 0 : schema.description3) !== null && _h !== void 0 ? _h : '', isContentCentered: schema === null || schema === void 0 ? void 0 : schema.isContentCentered, image: schema === null || schema === void 0 ? void 0 : schema.image, isBackButtonEnabled: !backButtonDisableFn(), backButtonAction: backButtonAction, primaryButtonText: renderPrimaryButtonText(), primaryButtonAction: primaryButtonAction, isPrimaryButtonDisabled: primaryButtonDisableFn(), isPrimaryButtonLoading: primaryButtonLoadingFn(), secondaryButtonText: renderSecondaryButtonText(), secondaryButtonAction: secondaryButtonAction, isSecondaryButtonDisabled: secondaryButtonDisableFn(), isLoading: configureAccount.devPlansLoading ||
            configureAccount.accountConfigLoading ||
            configureAccount.sendEmailVerificationLoading ||
            configureAccount.verifyEmailProcessing ||
            configureAccount.purchaseDevPlanLoading ||
            customerCardLoading ||
            paymentSettings.cardAssignLoading }, { children: renderChildren() })));
};
var mapStateToProps = function (state) { return ({
    configureAccount: selectConfigureAccount(state),
    user: selectMe(state),
    currentStep: selectCurrentStep(state),
    organizationId: selectOrganizationId(state),
    paymentSettings: selectPaymentModal(state),
    organization: selectOrg(state),
    developerPlans: selectDevPlans(state),
    devPlanStatus: selectDevPlanSummery(state),
    path: selectPath(state),
    customerCardLoading: selectStatusLoading(state),
}); };
var mapDispatchToProps = function (dispatch) { return ({
    getDeveloperPlans: function (orgId) {
        dispatch(actions.getDevPlans(orgId));
    },
    goToContinueModal: function () {
        dispatch(actions.setCurrentStep(NAVIGATE_STEP_KEYS.START));
    },
    goToEmailVerificationModal: function () {
        dispatch(actions.setCurrentStep(NAVIGATE_STEP_KEYS.EMAIL_VERIFICATION));
    },
    goToDevPlanSelectionModal: function () {
        dispatch(actions.setCurrentStep(NAVIGATE_STEP_KEYS.DEV_PLAN_SELECTION));
    },
    goToCardDetailsModal: function () {
        dispatch(actions.setCurrentStep(NAVIGATE_STEP_KEYS.CARD_DETAILS));
    },
    goToSuccessModal: function () {
        dispatch(actions.setCurrentStep(NAVIGATE_STEP_KEYS.SUCCESS));
    },
    holdModal: function () {
        dispatch(actions.holdModal());
    },
    resetState: function () {
        dispatch(actions.resetConfigureAccountState());
    },
    setSelectedDevPlanId: function (devPlanId) {
        dispatch(actions.setSelectedDevPlan(devPlanId));
    },
    setSelectedDevPlanTrialPeriod: function (devPlanTrial) {
        dispatch(actions.setSelectedDevPlanTrial(devPlanTrial));
    },
    setDevPlanInterval: function (interval) {
        dispatch(actions.setDevPlanInterval(interval));
        dispatch(changeInterval(interval));
    },
    purchaseDevPlan: function (devPlanId, orgId) {
        dispatch(actions.purchaseDevPlan(devPlanId, orgId));
    },
    createEmailVerificationData: function (key, data) {
        dispatch(actions.createEmailVerificationData(key, data));
    },
    sendEmailVerification: function (email) {
        dispatch(actions.sendEmailVerification(email));
    },
    verifyEmail: function (email, code) {
        dispatch(actions.verifyEmail(email, code));
    },
    refreshUserProfile: function () {
        dispatch(loadUserProfile());
    },
    refreshDevPlanStatus: function (orgId) {
        dispatch(checkOrgStatusSummery(orgId));
    },
    refreshOrgDevPlanList: function (orgId) {
        dispatch(listDeveloperPlansOrg(orgId));
    },
}); };
var withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(ConfigureAccountModal);
